<template>
    <div>
        <layout>
            <div slot="content" class="con">
                <swiper
                    v-if="goodsList.length > 0"
                    :options="swiperOption"
                    ref="swiperOption"
                    class="swiperWrap"
                >
                    <swiper-slide
                        v-for="(items, index) in goodsList"
                        :key="index"
                        class="swiperItem"
                    >
                        <img
                            :src="items.image[0].file_path"
                            @click="jump(items.goods_id)"
                        />
                        <div class="title">
                            <p>
                                {{ items.goods_name }} |
                                {{ items.sku[0].goods_weight.toFixed(2) }}克
                            </p>
                        </div>
                    </swiper-slide>
                    <div class="pagWrap" slot="pagination"></div>
                </swiper>
            </div>
        </layout>
    </div>
</template>
<script>
import { getList } from "../../api/http.js";
import layout from "@/components/layout.vue";
export default {
    components: {
        layout,
    },
    data() {
        return {
            goodsList: [],
            swiperOption: {
                watchSlidesProgress: true,
                slidesPerView: 'auto',
                centeredSlides: true,
                loop: true,
                loopedSlide: 5,
                autoplay: false,
              
                on: {
                    slideChange: function(){
                        this.slides[this.activeIndex].className  = 'swiperItem swiper-slide swiper-slide-active'

                        this.slides[this.activeIndex-1].className  = 'swiperItem swiper-slide swiper-slide-prev swiper-left'
                        this.slides[this.activeIndex+1].className  = 'swiperItem swiper-slide swiper-slide-prev swiper-right'


                    },
                    // progress: function (progress) {
                        // console.log(progress, this.slides)
                        // for (let i = 0; i < this.slides.length; i++) {
                        //   let slide = this.slides.eq(i);
                        //   let slideProgress = this.slides[i].progress;
                        //   let modify = 1;
                        //   // if (Math.abs(slideProgress) > 1) {
                        //   //   modify = (Math.abs(slideProgress) - 1) * 0.1 + 1;
                        //   // }
                        //   let translate = slideProgress * 279 + "px";
                        //   let scale = 1 - Math.abs(slideProgress) / 3;
                        //   if(slideProgress===0){
                        //     scale = 0.8;
                        //   }
                        //   let zIndex = 100 - Math.abs(Math.round(10 * slideProgress));
                        //   slide.transform(
                        //     "translateX(" + translate + ") scale(" + scale + ")"
                        //   );
                        //   slide.css("zIndex", zIndex);
                        //   slide.css("opacity", 1);
                        //   if (Math.abs(slideProgress) > 3) {
                        //     slide.css("opacity", 0);
                        //   }
                        // }
                    // },
                    setTransition: function (transition) {
                        for (let i = 0; i < this.slides.length; i++) {
                            let slide = this.slides.eq(i);
                            slide.transition(transition);
                        }
                    },
                },
            },
        };
    },
    created() {
        this.init();
    },
    computed: {
        imgheight() {
            return (this.$store.state.screenHeight - 175) / 102.4;
        },
    },
    methods: {
        init() {
            getList(1, "all", true, 0, "", "现货").then((res) => {
                this.goodsList = res.data.list.data;
                if(process.env.VUE_APP_ISAPP=='true'){
                    // this.goodsList.forEach(item=>{
                    //     item.image[0].file_path = './models/modelImgs/' + item.image[0].id+'.png'
                    // })
                    this.goodsList.forEach((item,index)=>{
                        window.electronAPI.isImgExisted(item.image[0].image_id+'.png',index)
                        window.electronAPI.on('isImgExistedRes',(isExisted,itemIndex)=>{
                            if(isExisted=='existed'){
                                this.goodsList[itemIndex].image[0].file_path = './models/modelImgs/' + this.goodsList[itemIndex].image[0].image_id+'.png'   
                            }
                        })
                    })
                }
            });
        },
        jump(ids) {
            this.$router.push({
                path: "/details",
                query: {
                    //路由传参时push和query搭配使用 ，作用是传递参数
                    id: ids,
                },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.con {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: url("../../assets/img/detailbg.jpg");
    background-size: 100%100%;
    .pagWrap{
        display: none;
    }
    .swiperWrap {
        // padding: 10px;
        padding-top: 10px;
        height: 100%;
        box-sizing: border-box;
        .swiper-slide-active{
            transform: scale(1)!important;
          
           z-index: 999;

            box-shadow: 0 0 20px #5a4e35;
        }
        .swiper-left{
            transform:scale(0.75) translateX(40%)!important;
        }
        .swiper-right{
            transform:scale(0.75) translateX(-40%)!important;
        }
        .swiperItem {
            width: 600px;
            height: 100%;
            display: flex;
            flex-direction:column;
            transform: scale(0.75);
            img {
                object-fit: contain;
                background: #000000;
                height: calc(100% - 60px) ;
                width: 100%;
            }
            .title {
                height: 60px;
                background: #2c2c2c;
                overflow: hidden;
                p {
                    height: 44px;
                    
                    margin: 8px auto;
                    line-height: 44px;
                    font-size: 16px;
                    text-align: center;
                    background: url("../../assets/img/bordertop.png");
                    background-size: 100%100%;
                    color: #d6ad58;
                }
            }
        }
    }
}
</style>
<style>
.pagWrap {
    right: 10px;
    top: 50%;
    transform: translate3d(0, -50%, 0);
    position: absolute;
    text-align: center;
    -webkit-transition: 0.3s opacity;
    -o-transition: 0.3s opacity;
    transition: 0.3s opacity;
    z-index: 10;
    bottom: initial !important;
    left: initial !important;
    width: initial !important;
}
.DetailItem {
    border-radius: 100%;
    background: #fff;
    opacity: 0.7;
    width: 8px;
    height: 8px;
    margin: 10px 0;
    display: block;
    line-height: 26px;
}
.DetailItemactive {
    background: #c9a864;
    opacity: 1;
}
</style>


